import React from 'react';
// Helper to extract square-bracket text from a string, and display it in its own em tag //
// Supports multiple pairs of square brackets throughout the text //
// e.g. TITLE [LINE 1] TITLE [LINE 2] becomes TITLE <em>LINE 1</em> TITLE <em>LINE 2</em> //
export const renderHighlightedText = (text) => {
    // Check for matching bracket pairs
    const openBrackets = (text.match(/\[/g) || []).length;
    const closeBrackets = (text.match(/\]/g) || []).length;
    if (!text) {
        return React.createElement(React.Fragment, null);
    }
    if (openBrackets !== closeBrackets) {
        return text.replace(/\[|\]/g, '');
    }
    const regex = /(\[.*?\])/g;
    const parts = text.split(regex);
    const predictableTextHash = text.replace(regex, '').trim().replace(/\s+/g, '_');
    return parts.map((part, index) => {
        const isMatch = part.startsWith('[') && part.endsWith(']');
        const shouldHighlight = !isMatch;
        if (shouldHighlight) {
            const word = isMatch ? part.slice(1, -1) : part;
            return word ? (React.createElement("em", { "data-highlighted-word": true, key: `${predictableTextHash}_highlighted_${index}` }, word)) : null;
        }
        if (isMatch) {
            return part.slice(1, -1);
        }
        return part;
    });
};
